module.exports = {
    // STANDARD ERRORS
    fallback: {
        all: {
            title: 'Außer Betrieb',
            subTitle: '',
            message: 'Leider konnte Ihre Anfrage nicht bearbeitet werden. Bitte versuchen Sie es in Kürze noch einmal.',
        },
    },
    notFound: {
        all: {
            title: 'Seite nicht gefunden',
            subTitle: '',
            message: 'Leider konnte die gesuchte Seite nicht gefunden werden.',
        },
        file: {
            title: 'Datei nicht gefunden',
            subTitle: '',
            message: 'Leider konnte die gesuchte Datei nicht gefunden werden.',
        },
        proxyCacheFileYet: {
            title: 'Datei wird gerade vorbereitet',
            subTitle: '',
            message: 'Sollte die Datei in einigen Minuten noch immer nicht zur Verfügung stehen wenden Sie sich bitte an den Webseiten-Betreiber.',
        },
    },
    clientError: {
        all: {
            title: 'Benötigen Sie Hilfe?',
            subTitle: '',
            message: 'Es wurde ein Fehler erkannt. Sollte diese Nachricht öfter angezeigt werden wenden Sie sich bitte an den Webseiten-Betreiber.',
        },
        'real-client-error': {
            title:    'Fehler',
            subTitle: '',
            message:  'Bei Ausführen dieser Funktion ist ein Fehler aufgetreten. Bitte kontaktieren Sie den Webseiten-Betreiber.',
        },
        'empty-action': {
            title:    'Fehler',
            subTitle: '',
            message:  'Diese Funktion steht im Moment nicht zur Verfügung. Wahrscheinlich sind gerade Wartungsarbeiten im Gange. Sollte das Problem dauerhaft bestehen kontaktieren Sie bitte den Webseiten-Betreiber.',
        },
    },



    // HTTP STATUS ERRORS
    '-1': {
        all: {
            title:    'Fehler',
            subTitle: 'Unerreichbar',
            message:  'Der Server ist im Moment Aufgrund von Wartungsarbeiten nicht erreichbar. Bitte versuchen Sie es später noch einmal.',
        },
        'internal-server-error': {
            title:    'Fehler',
            subTitle: 'Unerreichbar',
            message:  'Der Server ist im Moment Aufgrund von Wartungsarbeiten nicht erreichbar. Bitte versuchen Sie es später noch einmal.',
        },
    },
    0: {
        'not-reachable': {
            title:    'Fehler',
            subTitle: 'Unerreichbar',
            message:  'Der Server ist im Moment nicht erreichbar. Bitte warten Sie einen Moment und versuchen Sie es dann noch einmal.',
        },
    },
    403: {
        'user-provider-route-privilege-error': {
            title:    'Zugriff verweigert',
            subTitle: '',
            message:  'Sie haben keine Berechtigung diesen Vorgang auszuführen.',
        },
        'access-check-insufficient-rights': {
            title:    'Zugriff verweigert',
            subTitle: '',
            message:  'Sie haben keine Berechtigung diesen Vorgang auszuführen.',
        },
        'request-handler-validation-error-3': {
            title:    'Datenbank',
            subTitle: 'Unerwartet',
            message:  'Bei der letzten Datenbankabfrage ist ein unerwarteter Fehler aufgetreten. Wahrscheinlich sind gerade Wartungsarbeiten im Gange. Sollte das Problem dauerhaft bestehen kontaktieren Sie bitte den Webseiten-Betreiber.',
        },
        'api-privilege-error-1': {
            title:    'Zugriff verweigert',
            subTitle: '',
            message:  'Sie haben keine Berechtigung diesen Vorgang auszuführen.',
        },
        'api-privilege-error-2': {
            title:    'Zugriff verweigert',
            subTitle: '',
            message:  'Sie haben keine Berechtigung diesen Vorgang auszuführen.',
        },
        'api-privilege-error-3': {
            title:    'Zugriff verweigert',
            subTitle: '',
            message:  'Sie haben keine Berechtigung diesen Vorgang auszuführen.',
        },
        'api-privilege-error-4': {
            title:    'Zugriff verweigert',
            subTitle: '',
            message:  'Ihnen fehlen die nötigen Rechte um diesen Vorgang auszuführen.',
        },
        'api-privilege-error-5': {
            title:    'Zugriff verweigert',
            subTitle: '',
            message:  'Ihnen fehlen die nötigen Rechte um diesen Vorgang auszuführen.',
        },
        'fec-media-fallback-access-denied-error': {
            title:    'Zugriff verweigert',
            subTitle: '',
            message:  'Sie haben keine Berechtigung diese Datei zu laden.',
        },
    },
    404: {
        'api-route-not-found-error': {
            title:    'Fehler',
            subTitle: 'Datenbank',
            message:  'Beim Verbinden zur Datenbank ist ein Fehler aufgetreten.',
        },
        'route-not-found-according-to-index': {
            title:    'Fehler',
            subTitle: 'Neu Laden',
            message:  'Nachdem der Server gerade neu gestartet wurde ist es leider notwendig die Browser-Seite neu zu laden.',
        },
        'component-tree-builder-error-1': {
            title:    'Fehler',
            subTitle: 'Routen-Inhalt',
            message:  'Durch fehlerhafte Operationen wurde die Baum-Struktur der aktuellen Seite beschädigt.',
        },
        'data-query-privilege-error-1': {
            // TODO: model read not granted in data query
            title:    'Zugriff verweigert',
            subTitle: '',
            message:  'Ihnen fehlen die nötigen Rechte um diesen Vorgang auszuführen.',
        },
        'data-query-error-4': {
            title:    'Fehler',
            subTitle: 'Datenbank',
            message:  'Auf den angeforderten Daten-Type konnte nicht zugefriffen werdern.',
        },
        'request-handler-resource-not-found-error-1': {
            title:    'Fehler',
            subTitle: 'Datenbank',
            message:  'Der zu verändernde Datensatz konnte nicht gefunden werden.',
        },
        'request-handler-resource-not-found-error-2': {
            title:    'Fehler',
            subTitle: 'Datenbank',
            message:  'Der angeforderte Datensatz konnte nicht gefunden werden.',
        },
        'component-tree-root-detection-error-1': {
            title:    'Fehler',
            subTitle: 'Allgemein',
            message:  'Die angegebene Seite konnte nicht gefunden werden.',
        },
        'short-link-service-key-not-assigned': {
            title:    'Fehler',
            subTitle: 'Allgemein',
            message:  'Der angegebene Link konnte nicht gefunden werden.',
        },
        'document-not-found': 'Dokument konnte nicht gefunden werden.',
        'shadow-component-not-found': {
            title:    'Fehler',
            subTitle: 'Allgemein',
            message:  'Der Vorgang konnte nicht ausgeführt werden. Bitte laden Sie die Seite neu um das Problem zu beheben. Wenn das Problem weiterhin besteht, wenden Sie sich bitte an den Webseiten-Betreiber.',
        },
        'shadow-component-not-identified': {
            title:    '',
            subTitle: '',
            message:  'Diese Funktion steht im Moment nicht zur Verfügung. Eventuell könnte ein Neu-Laden der Seite das Problem beheben. Sollte das Problem dauerhaft bestehen kontaktieren Sie bitte den Webseiten-Betreiber.',
        },
        'fec-media-fallback-load-data-error-2': {
            title:    'Fehler',
            subTitle: 'fec-media-fallback-load-data-error-2',
            message:  'Die angeforderte Datei wurde nicht gefunden.',
        },
    },
    409: {
        'cms-routes-provider-validation-error-2': {
            title:    'Fehler',
            subTitle: 'Pfad leer',
            message:  'Der Pfad für diese Seite entsteht aus dem "Pfadname" Feld. Deshalb darf es nicht leer sein.',
        },
        'cms-routes-provider-error-3': {
            title:    'Fehler',
            subTitle: 'Pfad belegt',
            message:  'Der Pfad der Aufgrund des Feldes "Pfadname" entstehen würde existiert bereits. Bitte ändern Sie den Wert dieses Feldes.',
        },
        'sequelize-database-error': {
            title:    'Datenbank',
            subTitle: 'Unerwartet',
            message:  'Bei der letzten Datenbankabfrage ist ein unerwarteter Fehler aufgetreten.',
        },
        'sequelize-database-read-only': {
            title:    'Wartung',
            subTitle: 'Datenbank',
            message:  'Wir haben zu Wartungszwecken Ihre Datenbank mit einer Schreibsperre versehen. In Kürze sollte wieder die volle Funktionalität zur Verfügung stehen.',
        },
        'sequelize-validation-error': {
            title:    'Fehler',
            subTitle: 'Datenbank',
            message:  'Beim Verbinden zur Datenbank ist ein Fehler aufgetreten.',
        },
        'request-handler-postdata-validation-error-1': {
            title:    'Fehler',
            subTitle: 'Datenbank',
            message:  'Beim Einsortieren des neuen Datenbank-Eintrags ist ein Fehler aufgetreten.',
        },
        'usermanagement-provider-validation-error-3': {
            title:    'Fehler',
            subTitle: 'Eingabe',
            message:  'Leere Passwörter sind unzulässig!',
        },
    },
    500: {
        all: {
            title:    'Fehler',
            subTitle: 'Unerwartet',
            message:  'Leider ist ein unerwarteter Fehler aufgetreten.',
        },
        'internal-server-error': {
            title:    'Fehler',
            subTitle: 'Unerwartet',
            message:  'Leider ist ein unerwarteter Fehler aufgetreten.',
        },
        'activate-credentials-activation-key-not-assigned': {
            title:    'Fehler',
            subTitle: 'Bestätigung',
            message:  'Beim bestätigen Ihrer Daten ist ein Fehler aufgetreten. Das kann daran liegen, dass dieser Link bereits verwendet wurde oder mittlerweile abgelaufen ist.',
        },
        'sms-provider-not-granted': {
            title:    'Fehler',
            subTitle: 'SMS-Versand',
            message:  'Der SMS-Versand ist im Moment deaktiviert.',
        },
        'smsapi-error-code-13': {
            title:    'Fehler',
            subTitle: 'SMS-Versand',
            message:  'Die SMS konnte nicht versandt werden, da die betroffene Rufnummer ungültig ist oder nicht automatisch korrigiert werden konnte.<br><br>Bitte geben Sie die vollständige Rufnummer inklusive Vorwahl und gültiger Länderkennung ein. zB.: +43 650 1234567',
        },
    },
    504: {
        'container-not-reachable': {
            title:    'Fehler',
            subTitle: 'Unerreichbar',
            message:  'Der Server ist im Moment Aufgrund von Wartungsarbeiten nicht erreichbar. Bitte warten Sie einen Moment und versuchen Sie es dann noch einmal.',
        },
    },



    // COMMON ERRORS
    unknownPageTitle: 'Unbekannte Seite',
    confirm: {
        noTitleGiven: 'Frage?',
        noMessageGiven: 'NO MESSAGE GIVEN',
    },
    login: {
        credentialsError: 'Bei Ihrer Anfrage ist ein Fehler aufgetreten. Sollte das Problem dauerhaft bestehen wenden Sie sich bitte an den Webseiten-Betreiber.',
        inCompleteUserData: 'Bitte füllen Sie sowohl das Benutzernamen- als auch das Passwort-Feld aus!',
        emptyData: 'Benutzername / E-Mail und/oder Passwort müssen eingegeben werden.',
        emptyPassword: 'Bitte geben Sie ein Passwort ein.',
        invalidUserData: 'Benutzername und/oder Passwort nicht korrekt.',
        invalidMail: 'Die Eingabe entspricht keiner gültigen Email-Adresse!',
    },
    notAllowed: {
        media: {
            delete: 'Sie haben keine Berechtigung Medien zu löschen.',
        },
        form: {
            field: 'Ihnen fehlen die nötigen Zugriffsrechte für dieses Feld!',
        },
    },
    pluploader: {
        generic: 'Während des Hochladens ist ein Fehler aufgetreten.',
        http: 'Verbindung zum Server fehlgeschlagen.',
        io: 'Datei konnte nicht eingelesen werden.',
        security: 'Aus Sicherheitsgründen wurde das Hochladen der Datei blockiert.',
        'file-size': 'Eine der gewählten Dateien ist zu groß.\nEs sind maximal {{max_file_size}} pro Datei zulässig.',
        'file-extension': 'Eine der gewählten Dateien hat ein Format das nicht zum Hochladen freigegeben worden ist.',
        'file-duplicate': 'Eine der gewählten Dateien wurde bereits hochgeladen.',
        'image-format': 'Das Bildformat einer der gewählten Dateien konnte nicht ermittelt werden.',
        'image-dimensions': 'Eines der gewählten Bilder ist zu groß.',
        memory: 'Es steht zu wenig Arbeitsspeicher zur Verfügung. Bitte wählen Sie weniger Dateien auf einmal.',
        missingOwner: 'Ohne Benutzer-Datensatz sind keine Uploads gestattet.',
    },



    // SPECIAL ERRORS
    imageManagement: {
        tooSmallImageSelected: {
            title: 'Bild zu klein...',
            message: 'Dieses Bild ist zu klein für die maximal benötigte Größe. Ideal: {{max.width}}x{{max.height}} | "Gewähltes-Bild": {{image.width}}x{{image.height}} Möchten Sie es dennoch verwenden?',
        },
        delete: {
            noImagesSelected: 'Sie haben keine Bilder zum Löschen ausgewählt.',
        },
        showAssign: {
            tags: {
                noImagesSelected: 'Sie haben keine Bilder ausgewählt denen Tags zugewiesen werden sollen.',
                noMediaIDsFound: 'Bei der Auswahl ihrer Bilder ist ein Fehler aufgetreten.',
            },
        },
        missingMainDBEntry: {
            title: 'Dieses Bild wurde aus der Datenbank entfernt!',
        },
        permissionsDenied: {
            title: 'Zugriff verweigert',
        },
        cannotOpenMissingImage: {
            message: 'Es steht kein Bild zur Verfügung das geöffnet werden könnte!',
        },
    },
    fileManagement: {
        delete: {
            noFilesSelected: 'Sie haben keine Dateien zum Löschen ausgewählt.',
        },
        showAssign: {
            tags: {
                noFilesSelected: 'Sie haben keine Dateien ausgewählt denen Tags zugewiesen werden sollen.',
                noMediaIDsFound: 'Bei der Auswahl ihrer Dateien ist ein Fehler aufgetreten.',
            },
        },
        missingMainDBEntry: {
            title: 'Diese Datei wurde aus der Datenbank entfernt!',
        },
        permissionsDenied: {
            title: 'Zugriff verweigert',
        },
    },
    registration: {
        credentialsRouteError: 'Beim Registrieren des Benutzers ist ein Fehler aufgetreten. Im Regelfall wurden entweder die Daten nicht vollständig ausgefüllt, oder ein Benutzer mit dieser Kennung wurde bereits angelegt.<br><br>Sollte das nicht der Fall sein, das Problem aber weiterhin bestehen bitten wir Sie mit uns Kontakt aufzunehmen.',
    },
    events: {
        registration: {
            REGISTER_APPLICANT_MISSING_BASE_INFORMATION: 'Beim Abschicken der Formular-Daten ist ein Fehler aufgetreten. Bitte wenden Sie sich an den Webseiten-Betreiber. (1)',
            REGISTER_APPLICANT_MISSING_BASE_MAIL_INFORMATION: 'Beim Abschicken der Formular-Daten ist ein Fehler aufgetreten. Bitte wenden Sie sich an den Webseiten-Betreiber. (2)',
            REGISTER_APPLICANT_LOAD_APPLICANT_BY_EMAIL_HASH_ERROR: 'Beim Abschicken der Formular-Daten ist ein Fehler aufgetreten. Bitte wenden Sie sich an den Webseiten-Betreiber. (3)',
            REGISTER_APPLICANT_SEND_MAIL_ERROR: 'Beim beschicken der angegebenen Email-Adresse ist ein Fehler aufgetreten. Bitte überprüfen Sie die schreibweise...',

            LOAD_EVENT_BY_ROUTE_ERROR: 'Die Veranstaltung konnte nicht geladen werden. Wahrscheinlich wurde Sie gerade bearbeitet. Bitte laden Sie die Seite neu um es noch einmal zu versuchen. Wenn das nicht funktioniert wenden Sie sich bitte an den Webseiten-Betreiber.',
            LOAD_EVENT_BY_ROUTE_ERROR_MISSING_PARAMS: 'Beim Verifizieren Ihres Links ist ein Fehler aufgetreten. Bitte wenden Sie sich an den Webseiten-Betreiber.',

            APPLICANT_REGISTER_NOT_GRANTED_BY_PRIVATE_EVENT: 'Diese Veranstaltung ist für eine geschlossene Gesellschaft vorgesehen. Vielen Dank für Ihr Verständnis.',
            APPLICANT_REGISTER_NOT_GRANTED_BY_MISSING_OPT_IN: 'Bitte stimmen Sie zu im Kontext dieser Veranstaltung per Email beschickt zu werden um fortzufahren.',
            APPLICANT_REGISTER_NOT_GRANTED_BY_INVALID_MAIL: 'Beim Abschicken der Formular-Daten ist ein Fehler aufgetreten. Bitte wenden Sie sich an den Webseiten-Betreiber.',
            APPLICANT_REGISTER_NOT_GRANTED_BY_INVALID_APPLICANT_ID: 'Beim Abschicken der Formular-Daten ist ein Fehler aufgetreten. Bitte wenden Sie sich an den Webseiten-Betreiber.',
            APPLICANT_REGISTER_NOT_GRANTED_BY_INVALID_REGISTRATION_APPLICANT_ID: 'Beim Abschicken der Formular-Daten ist ein Fehler aufgetreten. Bitte wenden Sie sich an den Webseiten-Betreiber.',
            APPLICANT_REGISTER_NOT_GRANTED_BY_INVALID_REGISTRATION_ID: 'Beim Abschicken der Formular-Daten ist ein Fehler aufgetreten. Bitte wenden Sie sich an den Webseiten-Betreiber.',
            APPLICANT_REGISTER_NOT_GRANTED_BY_EVENT_REGISTRATION_TIME: 'Für diese Veranstaltung ist leider keine Anmeldung mehr möglich. Vielen Dank für Ihr Verständnis.',
            APPLICANT_REGISTER_NOT_GRANTED_BY_EVENT_STATUS: 'Für diese Veranstaltung ist leider keine Anmeldung mehr möglich. Vielen Dank für Ihr Verständnis.',
            APPLICANT_REGISTER_NOT_GRANTED_BY_BLOCK: 'Ihre Daten konnten nicht gespeichert werden. Bitte wenden Sie sich an den Webseiten-Betreiber.',

            APPLICANT_LOAD_NOT_GRANTED_BY_INVALID_AUTH_HASH: 'Ihre Daten konnten nicht geladen werden. Bitte wenden Sie sich an den Webseiten-Betreiber.',
            APPLICANT_LOAD_NOT_GRANTED_BY_BLOCK: 'Ihre Daten konnten nicht geladen werden. Bitte wenden Sie sich an den Webseiten-Betreiber.',
            APPLICANT_LOAD_NOT_GRANTED_BY_EVENT_REGISTRATION_TIME: 'Für diese Veranstaltung ist leider keine Anmeldung mehr möglich. Vielen Dank für Ihr Verständnis.',
            APPLICANT_LOAD_NOT_GRANTED_BY_EVENT_STATUS: 'Für diese Veranstaltung ist leider keine Anmeldung mehr möglich. Vielen Dank für Ihr Verständnis.',

            ROUTE_NOT_FOUND_ACCORDING_TO_INDEX: 'Der Server wurde gerade neu gestartet. Bitte laden Sie diese Seite neu und versuchen es dann noch einmal.',
            500: 'Der Server ist im Augenblick nicht erreichbar. Bitte warten Sie einen Moment und versuchen es dann erneut.',
        },
    },
}